import { UserProvider } from "@modules/user/context";
import { PoliciesProvider, ActivePolicyProvider } from "@modules/cve/context";
import { PoliciesTable, PolicyFormModalButton } from "@modules/cve/components";
import { translate } from "@utils";

export const PoliciesPage = () => {
	return (
		<UserProvider>
			<PoliciesProvider>
				<ActivePolicyProvider>
					<div style={{ margin: "0 10px", display: "flex", flexDirection: "column" }}>
						<h2>{translate("cve_policies_header")}</h2>
						<PolicyFormModalButton />
						<PoliciesTable />
					</div>
				</ActivePolicyProvider>
			</PoliciesProvider>
		</UserProvider>
	);
};
